import { ServiceFactory } from '@/services/ServiceFactory'

import * as constants from './admin-types'

const AdminService = ServiceFactory.get('admin')

export default {
  async [constants.GET_LISTS] ({ commit }, { token }) {
    const { data } = await AdminService.list({ token })
    commit(constants.SET_LISTS, data.result)
  },
}
